import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import thinkingAnimation from '@assets/lottie/andi_thinking_dev.json';

const ChatBotLoader = () =>
    <Player className="loader-animation" autoplay loop src={thinkingAnimation} style={{width: 20, height: 20}} />
;

export default ChatBotLoader;
